const toastMessages = {
  CONFIRM_SUCCESS_APPOINTMENT:
    'Votre choix a bien été pris en compte, si aucun rendez-vous ne vous convenait, veuillez prendre contact avec votre expert pour vous organiser.',
  ERROR_OCCURED_FETCH: 'Impossible de récupérer les données',
  CONFIRM_SUCCESS: 'Votre choix a été validé',
  PASSWORD_ERROR: 'Mot de passe incorrect',
};

export default toastMessages;
